import { Toaster as Sonner, type ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      gap={4}
      style={{ '--width': '600px' } as React.CSSProperties}
      toastOptions={{
        classNames: {
          toast: '!w-fit !text-primary !bg-white',
          description: '!text-primary-70 text-s',
        },
        style: {
          border: 'none',
          padding: 8,
          paddingLeft: 12,
          paddingRight: 12,
          borderRadius: 'var(--radius-xl)',
          top: -8,
          right: -8,
        },
      }}
      {...props}
      richColors
    />
  );
};

export { Toaster };
